import { classNames } from '../lib/classNames';
import { IHeroIcon } from '../../main/types/types';

interface ToolbarButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: IHeroIcon;
  primary?: boolean;
}

/** Compact page toolbar button from the invoice page design: filled primary or white outline, icon before the label */
export function ToolbarButton({ icon: Icon, primary, className, children, ...props }: ToolbarButtonProps) {
  return (
    <button
      type={ `button` }
      className={ classNames(`cursor-pointer`,
        `inline-flex h-8 items-center gap-1.5 whitespace-nowrap rounded-lg px-3 text-[0.8125rem] transition-colors disabled:cursor-not-allowed disabled:opacity-50`,
        primary ?
          `bg-paidniceGreen-600 font-medium text-white hover:bg-paidniceGreen-700` :
          `border border-gray-300 bg-white text-gray-700 hover:border-paidniceGreen-200 hover:bg-paidniceGreen-50`,
        className,
      ) }
      { ...props }
    >
      { Icon ? <Icon className={ classNames(`h-4 w-4 shrink-0`, primary ? `text-white` : `text-paidniceGreen-600`) } /> : null }
      { children }
    </button>
  );
}
